export default __webpack_public_path__ + "static/media/music.d9edb410.svg";